import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { Checkbox } from '../../../../../CommonComponents/OPL/Checkbox/Checkbox';
import { FormFields } from '../../../components/UpsertInsuranceModal/UpsertInsuranceModal.meta';
import { isConsumerArea } from '../../../../../CommonSelectors/CommonAreaSelector';

export const IsBrokerOfRecord = () => {
  const { register, setValue, watch } = useFormContext<FormFields>();
  const isBrokerOfRecordValue = watch('IsBrokerOfRecord');
  const [initialValue] = useState(isBrokerOfRecordValue);

  const isConsumer = useSelector(isConsumerArea);

  if (isConsumer) {
    return null;
  }

  const isBrokerOfRecordRegistry = register('IsBrokerOfRecord');

  return (
    <Checkbox
      {...isBrokerOfRecordRegistry}
      onChange={evt => {
        isBrokerOfRecordRegistry.onChange(evt);

        if (initialValue !== evt.target.checked) {
          setValue('HasAdvisorChangedBrokerOfRecord', true);
        } else {
          setValue('HasAdvisorChangedBrokerOfRecord', false);
        }
      }}
    >
      I&apos;m the broker of record for this account
    </Checkbox>
  );
};
